// export const getLetter = (index) => {
// 	const alphabets = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"]
// 	if (alphabets[index]) {
// 		return alphabets[index]
// 	}
// 	const remain  = index - (Math.floor(index/alphabets.length)*alphabets.length)
// 	return alphabets[remain]
// }

const alphabet = "A B C D E F G H I J K L M N O P Q R S T U V W X Y Z".split(
  " "
);

export function getLetter(index) {
  let code = alphabet[index % alphabet.length];
  if (index >= alphabet.length) {
    code = code + parseInt(index / alphabet.length);
  }
  return code;
}
